import {useIsFeatureActive} from '@aboutyou/feature-flags';
import {useEffect, useMemo, useState} from 'react';
import {
  HIDE_FOOTER_QUERY_PARAM,
  HIDE_HEADER_QUERY_PARAM,
} from '../../../client-services/LaunchTeaser/useFullScreenView';
import {getAppIntentUrlForDevices} from '../../../features/AppRedirect/helpers';
import {DEVICE_PARAM_TYPE} from '../../../features/Checkout/constants';

const CHATBOT_PARAM = 'chatbot';
const DEVICE_PARAM = 'device';

// The App opens the help center in a webview with /h?hideheader=1&hidefooter=1&device=ios&chatbot=1.
// Within the webview the user could navigate to a help center article, but by doing so all of the query parameters are lost.
// The help center article also has the chatbot trigger in the footer, so without the query params we can't know what intent to use.
// For that reason we preserve all needed query params values globally on entry to the help center.
let isHeaderDisabledGlobal = false;
let isFooterDisabledGlobal = false;
let isAppChatbotEnabledGlobal = false;
let deviceGlobal = '';

export const useHelpCenterChatbotActive = () => {
  const {isActive} = useIsFeatureActive('enable_cs_chatbot');
  const [isHeaderDisabled, setIsHeaderDisabled] = useState(
    isHeaderDisabledGlobal,
  );
  const [isFooterDisabled, setIsFooterDisabled] = useState(
    isFooterDisabledGlobal,
  );
  const [isAppChatbotEnabled, setIsAppChatbotEnabled] = useState(
    isAppChatbotEnabledGlobal,
  );
  const [device, setDevice] = useState(deviceGlobal);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);

    if (
      !isHeaderDisabledGlobal &&
      queryParams.get(HIDE_HEADER_QUERY_PARAM) === '1'
    ) {
      // eslint-disable-next-line local-rules/set-state-in-use-effect
      setIsHeaderDisabled(true);
      isHeaderDisabledGlobal = true;
    }

    if (
      !isFooterDisabledGlobal &&
      queryParams.get(HIDE_FOOTER_QUERY_PARAM) === '1'
    ) {
      setIsFooterDisabled(true);
      isFooterDisabledGlobal = true;
    }

    if (!isAppChatbotEnabledGlobal && queryParams.get(CHATBOT_PARAM) === '1') {
      setIsAppChatbotEnabled(true);
      isAppChatbotEnabledGlobal = true;
    }

    if (!deviceGlobal) {
      const device = queryParams.get(DEVICE_PARAM) || '';
      setDevice(device);
      deviceGlobal = device;
    }
  }, []);

  const appIntent = useMemo(
    () =>
      device
        ? getAppIntentUrlForDevices({
            device: device as DEVICE_PARAM_TYPE,
            intent: 'a/chatbot',
            searchParams: location.search,
          })
        : undefined,
    [device],
  );

  return {
    isActive: isActive && (!isHeaderDisabled || !isFooterDisabled),
    isActiveForApp: isActive && isAppChatbotEnabled,
    appIntent,
  };
};
